function resize() {
  this.logger.log(`resize ${this.currentScene} scene`);
  if (this.$variables && this.$variables.cache) {
    this.$variables.cache = {};
  }
}

export { resize };
